import React from 'react';
import { useBCMSContext, useRoute, BCMSRecord, BCMSDefaultModel } from "@bcm-dev/bcms-vite";
import './styles.css';
import { SVGAsset } from 'res';
import Classes, { Card } from 'model';

export default function MainContentContainer(props) {
  const className = props.className ?? "";
  const header = props.header ?? "";
  const dataPoint = props.dataPoint ?? false;

  // IMPORTANT: This code will automatically scroll nearly every page to the top on the first render.
  // It addresses an issue with "Workflow" components where they don't scroll to the top when 
  // navigating between pages when calling "nextStep" and "prevStep".
  window.scroll(0, 0);

  const controller = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, controller);

  window.customEvent = (name, value) => document.dispatchEvent(new CustomEvent(name, { detail: { value } }));

  document.addEventListener("force-global-card", evt => {
    const { crud, id, properties } = evt.detail.value;
    const defaultCard = properties.type && properties.type === "credit" ? BCMSDefaultModel.creditCard() : BCMSDefaultModel.debitCard();
    const existingCard = id ? Card.initByID(id).record : {};
    const cardID = id ?? Card.nextID();

    const card = Card.init(
      crud === "update"
        ? { ...existingCard, ...properties }
        : { ...defaultCard.record, ...properties }
    );
    const operation = crud === "update"
      ? Card.update(card)
      : Card.create({ ...card.record, cardID });

    BCMSRecord.batch([ operation ], controller, Classes);

    if(crud === undefined || crud === "create") {
      console.log(`Created Card ID: ${ cardID }`);
    }
  });

  return(
    <div className={className + " main-content-container"}>
     {dataPoint !== false && <span data-point={dataPoint}>{header}</span>}
      {dataPoint === false && <span >{header}</span>}    
      <div className="main-content">
        {props.children}
      </div>
    </div>
  );
}

export function MainContentHeader(props) {
  const navigate = useRoute();

  const onClick = props.onClick ?? function(){ navigate(-1); };
  const text = props.text ?? "";
  const dataPoint = props.dataPoint ? {"data-point":props.dataPoint}:{};
  const showChevron = props.showChevron ?? true;


  return(
    <div className="main-content-header-container flex-container flex-horizontal align-center-container">
      { showChevron && <SVGAsset className="chevron-icon clickable" id="LeftChevronIcon" onClick={onClick} data-point={props.dataPoint+"_Back_Button"}/> }

      <b className="flex-width flex-shrink-item text-center">{<span {...dataPoint}>{text}</span>}</b>
        <div className="set-width text-right justify-right">
        {props.children}
      </div>
    </div>
  );
}

export function MainContentSection(props) {
  const className = props.className ?? "";
  const text = props.text ?? "";
  const icon = props.icon ?? "";
  const dataPoint = props.dataPoint ? {"data-point":props.dataPoint}:{};

  return(
    <div className={className + " main-content-section-container"}>
      <div className="main-content-section-header-container flex-container flex-horizontal align-center-container">
        <b className="flex-width" ><span  {...dataPoint}>{text}</span></b>
        <div className="set-width">{icon}</div>
      </div>
      <div className="main-content-section">
        {props.children}
      </div>
    </div>
  );
}
